import { Backdrop, Button, Card, CardContent, CardHeader, Checkbox, CircularProgress, Container, Divider, Grid, IconButton, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Dialog, DialogTitle, DialogActions, DialogContent, Typography, TableSortLabel, Paper, Chip, Tooltip, Box, TablePagination } from '@mui/material';
import Alert from 'src/components/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getUser } from 'src/utils/Common';
import Page from 'src/components/Page';
import SectionBlock from 'src/components/SectionBlock';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import CloseIcon from '@mui/icons-material/Close';
import Tarihce from 'src/views/History';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import trLocale from 'date-fns/locale/tr';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'src/utils/axios';
import moment from 'moment';
import ServiceDigitalForms from 'src/components/ServiceDigitalForms';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BlockIcon from '@mui/icons-material/Block';
import AssignmentIcon from '@mui/icons-material/Assignment';

const localeMap = {
    tr: trLocale
};

// ==========================================
// UTILITY FUNCTIONS (Component dışında)
// ==========================================

// Durum listesinden ID array oluştur
const getDurumIdList = (selectedDurum) => {
    return selectedDurum.map(item => item.DURUM_ID);
};

// Sorting utility fonksiyonları
const descendingComparator = (a, b, orderBy) => {
    if (a[orderBy] === null && b[orderBy] !== null) return 1;
    if (a[orderBy] !== null && b[orderBy] === null) return -1;
    if (a[orderBy] === null && b[orderBy] === null) return 0;

    if (typeof a[orderBy] === 'undefined' && typeof b[orderBy] !== 'undefined') return 1;
    if (typeof a[orderBy] !== 'undefined' && typeof b[orderBy] === 'undefined') return -1;
    if (typeof a[orderBy] === 'undefined' && typeof b[orderBy] === 'undefined') return 0;

    if (typeof a[orderBy] === 'number' && typeof b[orderBy] === 'string') return 1;
    if (typeof a[orderBy] === 'string' && typeof b[orderBy] === 'number') return -1;

    if (typeof a[orderBy] === 'number' && typeof b[orderBy] === 'number') {
        return b[orderBy] - a[orderBy];
    }

    return (b[orderBy] || '').localeCompare(a[orderBy] || '');
};

const getComparator = (order, orderBy) => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

const stableSortDocuments = (array, order, orderBy) => {
    if (!array || array.length === 0) return [];
    const comparator = getComparator(order, orderBy);
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const ord = comparator(a[0], b[0]);
        if (ord !== 0) return ord;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

// ==========================================
// STYLES (Component dışında - performans için)
// ==========================================
const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    }),
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    })
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;

// ==========================================
// COMPONENT
// ==========================================
function LaborManagement() {

    // State tanımlamaları
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const SessionUser = getUser();
    const [anketBitti, setAnketBitti] = useState(false);
    const [singlePopUp, setSinglePopUp] = useState(false);
    const [yorumAciklama, setYorumAciklama] = useState('');

    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    const [durum, setDurum] = useState([]);
    const [selectedDurum, setSelectedDurum] = useState([]);

    const [talepEdilmeBaslangicTarihi, setTalepEdilmeBaslangicTarihi] = useState(
        new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    );

    const [talepEdilmeBitisTarihi, setTalepEdilmeBitisTarihi] = useState(
        new Date()
    );

    // Memoized değerler (performans için)
    const formattedBaslangicDate = useMemo(() =>
        moment(talepEdilmeBaslangicTarihi).format('MM-DD-YYYY'),
        [talepEdilmeBaslangicTarihi]
    );

    const formattedBitisDate = useMemo(() =>
        moment(talepEdilmeBitisTarihi).format('MM-DD-YYYY'),
        [talepEdilmeBitisTarihi]
    );

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedDurumId, setSelectedDurumId] = useState(0);
    const [tarihcePopUp, setTarihcePopUp] = useState(false);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('SURECTIPI');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [formTypes, setFormTypes] = useState([]);
    const [anketGoster, setAnketGoster] = useState(false);
    const [anketData, setAnketData] = useState({});
    const [formData, setFormData] = useState({});
    const [readOnly, setReadOnly] = useState(false);
    const [mesaj, setMesaj] = useState('');
    const [documents, setDocuments] = useState([]);
    const [Required, setRequired] = useState(false);

    // ==========================================
    // API FUNCTIONS
    // ==========================================

    // Durum adımlarını getir
    const getLaborSteps = useCallback(async () => {
        try {
            const response = await axios.get("/getLaborSteps");
            setDurum(response.data || []);
        } catch (error) {
            console.error("Durum adımları yüklenirken hata:", error);
            setresponseMessage('Durum adımları yüklenemedi');
            setUyariTip('error');
            setUyari(true);
        }
    }, []);

    // Form kategorilerini getir
    const getServiceFormCategories = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.get('getLaborFormCategories');
            setFormTypes(response.data?.FormTypes || []);
        } catch (error) {
            console.error("Form kategorileri yüklenirken hata:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    // Hizmet formlarını getir (birleştirilmiş fonksiyon)
    // durumOverride: Opsiyonel - state yerine kullanılacak durum ID listesi
    const fetchHizmetForms = useCallback(async (showValidationError = false, durumOverride = null) => {
        // Kullanılacak durum listesini belirle
        const durumToUse = durumOverride || selectedDurum;

        if (showValidationError && durumToUse.length === 0) {
            setresponseMessage('Lütfen önce durum seçimi yapınız!');
            setUyariTip('error');
            setUyari(true);
            return;
        }

        const durumIdList = durumOverride
            ? durumOverride.map(d => d.DURUM_ID ?? d.ID ?? d.Id ?? d).filter(id => typeof id === 'number' || (typeof id === 'string' && id !== '[object Object]'))
            : getDurumIdList(selectedDurum);

        if (durumIdList.length === 0) return;

        setLoading(true);
        try {
            const response = await axios.get(
                `GetApolloHizmetForm/${durumIdList.toString()}/${formattedBaslangicDate}/${formattedBitisDate}/${SessionUser.UserId}`
            );
            setDocuments(response.data || []);
            setPage(0);
        } catch (error) {
            console.error("Formlar yüklenirken hata:", error);
            setresponseMessage('Veriler yüklenirken bir hata oluştu');
            setUyariTip('error');
            setUyari(true);
            setDocuments([]);
        } finally {
            setLoading(false);
        }
    }, [selectedDurum, formattedBaslangicDate, formattedBitisDate, SessionUser.UserId]);

    // Sayfa yüklendiğinde (sadece dropdown verilerini getir)
    useEffect(() => {
        getServiceFormCategories();
        getLaborSteps();
    }, []);

    // Filtreleme ve arama
    const GeneralDataFiltreleAra = useCallback(() => {
        fetchHizmetForms(true);
    }, [fetchHizmetForms]);

    // ==========================================
    // EVENT HANDLERS
    // ==========================================

    const handleRequestSort = useCallback((property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    }, [order, orderBy]);

    const handleChangePage = useCallback((event, newPage) => {
        setPage(newPage);
    }, []);

    const handleChangeRowsPerPage = useCallback((event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }, []);

    const handleYorum = useCallback((row) => {
        setSelectedIndex(row.ID);
        setTarihcePopUp(true);
    }, []);

    // Form tamamlandığında
    const onComplete = useCallback(async (survey) => {
        setLoading(true);
        const data = {
            FormData: JSON.stringify(survey.data),
            FormType: 10,
            ServiceShopId: 0,
            UserId: SessionUser.UserId,
            Type: 5
        };

        try {
            const response = await axios.post('/SetApolloForm', data, {
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.data?.ErrorCode === "OK") {
                setAnketBitti(true);
                setMesaj(response.data.ErrorDescription || "Form başarıyla kaydedildi.");
                setresponseMessage('Form başarıyla kaydedildi');
                setUyariTip('success');
                setUyari(true);
                setAnketGoster(false);

                // Listeyi yenile - filtre seçiliyse mevcut filtreyle, değilse tüm durumlarla
                if (selectedDurum.length > 0) {
                    await fetchHizmetForms(false, selectedDurum);
                } else if (durum.length > 0) {
                    // Tüm durumları seç ve ara
                    setSelectedDurum(durum);
                    await fetchHizmetForms(false, durum);
                } else {
                    // Durum listesi henüz yüklenmemişse tekrar yükle
                    const stepsResponse = await axios.get("/getLaborSteps");
                    if (stepsResponse.data && stepsResponse.data.length > 0) {
                        setDurum(stepsResponse.data);
                        setSelectedDurum(stepsResponse.data);
                        await fetchHizmetForms(false, stepsResponse.data);
                    }
                }
            } else {
                setAnketBitti(true);
                setMesaj(response.data?.ErrorDescription || "Bir hata oluştu.");
            }
        } catch (error) {
            console.error("Form kaydedilirken hata:", error);
            setAnketBitti(true);
            setMesaj("Sunucuya bağlanılamadı.");
        } finally {
            setLoading(false);
        }
    }, [SessionUser.UserId, fetchHizmetForms, selectedDurum, durum]);

    // Form popup kapat
    const handleAnketKapat = useCallback(() => {
        setAnketGoster(false);
    }, []);

    // Yeni form oluştur
    const handleCreateForm = useCallback(() => {
        if (!formTypes || formTypes.length === 0) {
            setresponseMessage('Form şablonu bulunamadı');
            setUyariTip('error');
            setUyari(true);
            return;
        }
        setAnketData(formTypes[0].Data);
        setAnketGoster(true);
        setReadOnly(false);
        setFormData({});
        setAnketBitti(false);
    }, [formTypes]);

    // Onay/Red popup aç
    const handleSinglePopUp = useCallback((row) => {
        setSelectedIndex(row.ID);
        setSelectedDurumId(row.DURUM_ID);
        setSinglePopUp(true);
        setYorumAciklama('');
    }, []);

    // Onay/Red kaydet
    const handleSave = useCallback(async (caseValue) => {
        // Validasyon
        if (!yorumAciklama || yorumAciklama.trim() === '') {
            setRequired(true);
            return;
        }

        const data = [{
            Id: selectedIndex,
            Yorum: yorumAciklama.trim(),
            UserId: SessionUser.UserId,
            Role_Id: 0,
            Durum: selectedDurumId,
            Case: caseValue
        }];

        setLoading(true);
        try {
            const response = await axios.post("SetApolloHizmetFormBasvuruOnay", data, {
                headers: { "Content-Type": "application/json" }
            });

            const res = response.data[0];
            setresponseMessage(res.ErrorDescription);
            setUyariTip(res.ErrorCode === "OK" ? "success" : "error");
            setUyari(true);
            setSinglePopUp(false);

            if (res.ErrorCode === "OK") {
                setRequired(false);
                // Listeyi yenile - filtre seçiliyse mevcut filtreyle, değilse ilk durumla veya tüm durumlarla
                if (selectedDurum.length > 0) {
                    await fetchHizmetForms(false, selectedDurum);
                } else if (durum.length > 0) {
                    // Tüm durumları seç ve ara
                    setSelectedDurum(durum);
                    await fetchHizmetForms(false, durum);
                } else {
                    // Durum listesi henüz yüklenmemişse tekrar yükle
                    const stepsResponse = await axios.get("/getLaborSteps");
                    if (stepsResponse.data && stepsResponse.data.length > 0) {
                        setDurum(stepsResponse.data);
                        setSelectedDurum(stepsResponse.data);
                        await fetchHizmetForms(false, stepsResponse.data);
                    }
                }
            }
        } catch (error) {
            console.error("Onay/Red işlemi sırasında hata:", error);
            setresponseMessage('İşlem sırasında bir hata oluştu');
            setUyariTip('error');
            setUyari(true);
        } finally {
            setLoading(false);
        }
    }, [yorumAciklama, selectedIndex, selectedDurumId, SessionUser.UserId, fetchHizmetForms, selectedDurum, durum]);

    // Durum chip rengini belirle (MUI standart renkleri)
    const getDurumChipColor = (durumId) => {
        switch (durumId) {
            case 0: // Form Oluşturuldu
                return 'info';
            case 1: // Onay Bekliyor - THKD
            case 3: // Onay Bekliyor - SKAY
            case 5: // Onay Bekliyor - SDKD
                return 'warning';
            case 2: // Reddedildi - THKD
            case 4: // Reddedildi - SKAY
            case 6: // Reddedildi - SDKD
                return 'error';
            case 7: // Tüm Onaylar Tamamlandı
                return 'success';
            case 8: // İptal Edildi
                return 'default';
            default:
                return 'warning';
        }
    };

    const sortedRows = stableSortDocuments(documents, order, orderBy);
    const paginatedRows = sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Page sx={styles.root}>
            <Backdrop sx={styles.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={6000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={typeof responseMessage === 'string' ? responseMessage : responseMessage?.ErrorDescription}
                ></Alert>
            </Snackbar>
            <Container maxWidth="xl">
                <Card>
                    <CardHeader title="Hizmet/İşçilik Yönetimi" />
                    <Divider />
                    <CardContent>
                        <SectionBlock title="Filtreleme">
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    lg: 2
                                }}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    id="multiple-limit-tags"
                                    fullWidth
                                    limitTags={1}
                                    disableCloseOnSelect
                                    value={selectedDurum}
                                    options={durum}
                                    getOptionLabel={option => (option.DURUM ? option.DURUM : '')}
                                    onChange={(event, newValue) => setSelectedDurum(newValue)}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option.DURUM}
                                        </li>
                                    )}
                                    renderInput={params => (
                                        <TextField {...params} label="Durum" variant="outlined" />
                                    )}
                                />
                            </Grid>

                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    lg: 2
                                }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={localeMap['tr']}>
                                    <DatePicker
                                        label="Başlangıç Tarihi"
                                        format="dd.MM.yyyy"
                                        value={talepEdilmeBaslangicTarihi}
                                        onChange={date => setTalepEdilmeBaslangicTarihi(date)}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: 'small',
                                                color: 'primary',
                                                variant: 'outlined'
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    lg: 2
                                }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={localeMap['tr']}>
                                    <DatePicker
                                        label="Bitiş Tarihi"
                                        format="dd.MM.yyyy"
                                        value={talepEdilmeBitisTarihi}
                                        onChange={date => setTalepEdilmeBitisTarihi(date)}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: 'small',
                                                color: 'primary',
                                                variant: 'outlined'
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    lg: 6
                                }}
                                sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, flexWrap: 'wrap' }}
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => GeneralDataFiltreleAra()}
                                    startIcon={<SearchIcon />}
                                >
                                    Ara
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => handleCreateForm()}
                                    startIcon={<AddIcon />}
                                >
                                    Yeni Form Oluştur
                                </Button>
                            </Grid>
                        </SectionBlock>

                        <TableContainer component={Paper} variant="outlined">
                            <Table stickyHeader aria-label="sticky table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            align="left"
                                            sortDirection={orderBy === 'SURECTIPI' ? order : false}
                                        >
                                            <TableSortLabel
                                                active={orderBy === 'SURECTIPI'}
                                                direction={orderBy === 'SURECTIPI' ? order : 'asc'}
                                                onClick={() => handleRequestSort('SURECTIPI')}
                                            >
                                                Form Adı
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell
                                            align="left"
                                            sortDirection={orderBy === 'DURUM' ? order : false}
                                        >
                                            <TableSortLabel
                                                active={orderBy === 'DURUM'}
                                                direction={orderBy === 'DURUM' ? order : 'asc'}
                                                onClick={() => handleRequestSort('DURUM')}
                                            >
                                                Mevcut Durum
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell
                                            align="left"
                                            sortDirection={orderBy === 'SONRAKI_DURUM' ? order : false}
                                        >
                                            <TableSortLabel
                                                active={orderBy === 'SONRAKI_DURUM'}
                                                direction={orderBy === 'SONRAKI_DURUM' ? order : 'asc'}
                                                onClick={() => handleRequestSort('SONRAKI_DURUM')}
                                            >
                                                Sonraki Adım
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell
                                            align="left"
                                            sortDirection={orderBy === 'SERVISBILGI' ? order : false}
                                        >
                                            <TableSortLabel
                                                active={orderBy === 'SERVISBILGI'}
                                                direction={orderBy === 'SERVISBILGI' ? order : 'asc'}
                                                onClick={() => handleRequestSort('SERVISBILGI')}
                                            >
                                                Açıklama
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center">Yorumlar</TableCell>
                                        <TableCell align="center">Form</TableCell>
                                        <TableCell align="left">Oluşturan</TableCell>
                                        <TableCell align="center">İşlemler</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedRows.length > 0 ? paginatedRows.map((row) => (
                                        <TableRow
                                            key={row.ID}
                                            style={row.ID === selectedIndex ? { backgroundColor: '#FFE0B2' } : {}}
                                        >
                                            <TableCell>{row.FORM_ADI}</TableCell>
                                            <TableCell>
                                                <Chip
                                                    size="small"
                                                    variant="outlined"
                                                    label={
                                                        row.DURUM_ID === 0
                                                            ? (row.DURUM || '-')
                                                            : (row.SONRAKI_DURUM?.split('›')[0]?.trim() || '-')
                                                    }
                                                    color={getDurumChipColor(row.DURUM_ID)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    size="small"
                                                    variant="outlined"
                                                    color="info"
                                                    label={
                                                        row.DURUM_ID === 0
                                                            ? (row.SONRAKI_DURUM || '-')
                                                            : (row.SONRAKI_DURUM?.split('›')[1]?.trim() || '-')
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell>{row.FORM_ACIKLAMA || '-'}</TableCell>
                                            <TableCell align="center">
                                                <Tooltip title="Yorumları Görüntüle" arrow>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleYorum(row)}
                                                        style={{ backgroundColor: '#19ecff', color: 'white' }}
                                                    >
                                                        <CommentOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Tooltip title="Formu Görüntüle" arrow>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => {
                                                            setReadOnly(true);
                                                            setAnketGoster(true);
                                                            setAnketData(row.AnketSoru);
                                                            setFormData(row.AnketCevap);
                                                            setAnketBitti(false);
                                                        }}
                                                        style={{ backgroundColor: '#FF7F00', color: 'white' }}
                                                    >
                                                        <DescriptionIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell>{row.ACIKLAMA || '-'}</TableCell>
                                            <TableCell align="center">
                                                <Tooltip title="Onayla / Reddet" arrow>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleSinglePopUp(row)}
                                                        style={{ backgroundColor: '#FF7F00', color: 'white' }}
                                                    >
                                                        <DoneAllIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Box sx={{ textAlign: 'center', py: 6 }}>
                                                    <AssignmentIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 1 }} />
                                                    <Typography sx={{ color: 'text.secondary' }}>
                                                        Henüz kayıt bulunmamaktadır
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: 'text.disabled' }}>
                                                        Filtreleme yaparak kayıtları görüntüleyebilir veya yeni form oluşturabilirsiniz.
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            count={sortedRows.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            labelRowsPerPage="Sayfa başına satır"
                        />
                    </CardContent>

                    {/* Yorum Geçmişi Dialog */}
                    <Dialog
                        open={tarihcePopUp}
                        fullWidth
                        maxWidth="lg"
                        onClose={() => setTarihcePopUp(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Yorum Geçmişi</DialogTitle>
                        <Divider />
                        <DialogContent>
                            <Tarihce BasvuruId={selectedIndex} readonly={false} OpenClose={5} />
                        </DialogContent>
                        <DialogActions>
                            <IconButton color="primary" onClick={() => setTarihcePopUp(false)}>
                                <CloseIcon />
                            </IconButton>
                        </DialogActions>
                    </Dialog>

                    {/* Form Dialog */}
                    <Dialog
                        open={anketGoster}
                        onClose={(event, reason) => {
                            if (reason !== 'backdropClick') {
                                handleAnketKapat();
                            }
                        }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth
                        fullScreen
                    >
                        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            {readOnly ? 'Form Görüntüleme' : 'Yeni Form Oluştur'}
                            <IconButton onClick={() => handleAnketKapat()} size="small">
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <Divider />
                        <DialogContent>
                            {loading ? (
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300 }}>
                                    <CircularProgress size={50} color="secondary" />
                                    <Typography sx={{ mt: 2, color: 'text.secondary' }}>
                                        Yükleniyor...
                                    </Typography>
                                </Box>
                            ) : anketBitti ? (
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300 }}>
                                    <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
                                    <Typography variant="h6" sx={{ color: 'success.main' }}>
                                        {mesaj}
                                    </Typography>
                                </Box>
                            ) : (
                                <ServiceDigitalForms
                                    anketSoru={anketData}
                                    anketCevap={formData}
                                    onComplete={onComplete}
                                    readonly={readOnly}
                                    serviceCodeQuestion={""}
                                    serviceNameQuestion={""}
                                    serviceFullNameQuestion={""}
                                    serviceShopFullName={""}
                                />
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleAnketKapat()}>Kapat</Button>
                        </DialogActions>
                    </Dialog>

                    {/* Onay/Red Dialog */}
                    <Dialog
                        open={singlePopUp}
                        fullWidth
                        maxWidth="sm"
                        onClose={() => setSinglePopUp(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            Onay / Red İşlemi
                            <IconButton onClick={() => setSinglePopUp(false)} size="small">
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <Divider />
                        <DialogContent>
                            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                                İşlem için bir yorum yazınız. Bu yorum kayıt geçmişinde görüntülenecektir.
                            </Typography>
                            <TextField
                                size="small"
                                id="desc"
                                autoComplete="off"
                                multiline
                                error={yorumAciklama?.length > 0 ? false : Required}
                                helperText={Required && !yorumAciklama ? 'Yorum alanı zorunludur' : ''}
                                rows={8}
                                value={yorumAciklama}
                                onChange={(event) => setYorumAciklama(event.target.value)}
                                fullWidth
                                label="Yorumunuz"
                                variant="outlined"
                                placeholder="Onay veya red sebebinizi yazınız..."
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => handleSave(1)}
                                variant="contained"
                                color="error"
                                startIcon={<BlockIcon />}
                            >
                                Reddet
                            </Button>
                            <Button
                                onClick={() => handleSave(0)}
                                variant="contained"
                                color="success"
                                startIcon={<CheckCircleOutlineIcon />}
                            >
                                Onayla
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Card>
            </Container>
        </Page>
    );
}

export default LaborManagement;
